import { apolloClient } from '../graphql/apollo'
import {
  CREATE_BIOMARKER,
  UPDATE_BIOMARKER,
  DELETE_BIOMARKER
} from '../graphql/queries/BiomarkerQueries'

export const createBiomarker = async biomarker => {
  try {
    const biomarkerCreate = { ...biomarker }
    const created = await apolloClient.mutate({
      mutation: CREATE_BIOMARKER,
      variables: { biomarkerCreate }
    })
    return created.data.createBiomarker
  } catch (e) {
    console.log(e)
  }
}

export const updateBiomarker = async biomarker => {
  try {
    const biomarkerUpdate = { ...biomarker }
    const updated = await apolloClient.mutate({
      mutation: UPDATE_BIOMARKER,
      variables: { biomarkerUpdate }
    })
    return updated.data.updateBiomarker
  } catch (e) {
    console.log(e)
  }
}

export const deleteBiomarker = async id => {
  try {
    const report = await apolloClient.mutate({
      mutation: DELETE_BIOMARKER,
      variables: { id }
    })
    return report.data.deleteBiomarker
  } catch (e) {
    console.log(e)
  }
}
